import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

const LABEL = { follow: "Follow", follow_back: "Follow Back", following: "Following", friends: "Friends" };

// A relationship button that reflects Follow / Follow Back / Following / Friends and
// optimistically toggles. `state` is one of those keys; `followsMe` decides the next state.
export function FollowButton({ username, state, followsMe, onChange, size = "sm", testid }) {
  const [st, setSt] = useState(state);
  const [busy, setBusy] = useState(false);
  const isFollowing = st === "following" || st === "friends";

  const click = async (e) => {
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    const next = isFollowing ? (followsMe ? "follow_back" : "follow") : (followsMe ? "friends" : "following");
    setSt(next);
    onChange && onChange(next);
    try {
      if (isFollowing) await api.unfollow(username);
      else await api.follow(username);
    } catch (err) {
      setSt(st); onChange && onChange(st); toast(err.message);
    } finally { setBusy(false); }
  };

  return (
    <button
      onClick={click}
      disabled={busy}
      data-testid={testid || `follow-btn-${username}`}
      className={cn(
        "shrink-0 rounded-full font-bold transition-all disabled:opacity-60",
        size === "sm" ? "px-4 py-1.5 text-xs" : "px-6 py-2 text-sm",
        isFollowing ? "border border-am-border-strong text-white hover:bg-white/5" : "aura-gradient text-black hover:scale-[1.02]"
      )}
    >
      {LABEL[st]}
    </button>
  );
}
